// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageBackground_container__S2vOw","bgWrap":"ImageBackground_bgWrap__GiiN7","children":"ImageBackground_children__F1S_D"};